import { jsx as l } from "react/jsx-runtime";
import { useIDSTableColumnStyles as c } from "../hooks/useIDSTableColumnStyles.js";
const h = ({
  cellApi: o,
  children: s,
  hiddenHeader: m,
  index: d,
  scope: r = "row",
  tableId: e,
  ...i
}) => {
  const u = c({
    columnKey: o.column.id
  }), n = d === 0 && r === "row", t = m ? [] : [`${e}__${o.column.id}`];
  return !n && r === "row" && t.push(`${e}__${o.row.getVisibleCells()[0].id}`), /* @__PURE__ */ l(
    n ? "th" : "td",
    {
      ...i,
      "data-column": o.column.id,
      headers: t.length ? t.join(" ") : void 0,
      id: `${e}__${o.id}`,
      scope: n ? "row" : void 0,
      ...u,
      children: s
    }
  );
};
export {
  h as TableBodyCell
};
